// @flow

import * as React from 'react';
import {useNavigation} from 'docs/data';
import {Executable} from './_executable';
import {parsePath, search, Pages} from '../helpers/executables/docs_navtree';

const ListDirectory = (props: {currentPath: string, command: string}) => {
  const {navigation} = useNavigation();
  const {currentPath, command} = props;

  const currentPage = search(currentPath, Pages(navigation));
  if (currentPage === null) {
    return <p>Error, something went wrong.</p>;
  }

  const page = parsePath(command, currentPage, navigation);
  if (page === null) {
    return <p>page not found: {command}</p>;
  }

  const pages = page.children.map((child, idx) => {
    if (child.slug !== currentPage.slug) {
      return (
        <tr key={idx}>
          <td>{child.slug}/</td>
          <td> -- {child.title}</td>
        </tr>
      );
    } else {
      return child.children.map((childNode, innerChildIdx) => {
        return (
          <tr key={innerChildIdx}>
            <td>
              {child.slug}/{childNode.slug}/
            </td>
            <td>
              {' '}
              -- {child.title} - {childNode.title}
            </td>
          </tr>
        );
      });
    }
  });

  if (page.parent !== null && page.parent !== undefined) {
    pages.unshift(
      <tr key={-1}>
        <td>
          <b>..</b>
        </td>
        <td> -- {page.parent.title}</td>
      </tr>,
    );
  }

  pages.unshift(
    <tr key={-2}>
      <td>
        <b>.</b>
      </td>
      <td> -- {page.title}</td>
    </tr>,
  );

  return (
    <table>
      <tbody>{pages}</tbody>
    </table>
  );
};
export class ls extends Executable {
  commandName(): string {
    return 'ls';
  }

  shortHelp(): string {
    return 'lists pages relative to the current one';
  }

  help() {
    this.setAllowInput(true);
    return <p>ls (list pages) - lists pages relative to the current one</p>;
  }

  run() {
    // no flags support (yet!)
    if (this.command.structuredFlags.length !== 0) {
      this.setAllowInput(true);
      return (
        <p>
          ls does not take any flags, given:{' '}
          {this.command.structuredFlags.join(' ')}
        </p>
      );
    }

    // Form the passed in command for later parsing. Running the ls
    // command with no arguments, but acts as a check for the current
    // directly so return '.'. Otherwise, merge spaces (in the future
    // we should probably remove support to pass folders with spaces)
    const command =
      this.command.structuredArgs.length === 0
        ? '.'
        : this.command.structuredArgs.join(' ');

    this.setAllowInput(true);
    return (
      <ListDirectory currentPath={window.location.pathname} command={command} />
    );
  }
}
